import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "@/components/ui/button";
import { GripVertical, Pencil, Trash2, Star, Check } from "lucide-react";
import { displayUrl } from "./imageUrl";

export const SortableImageCard = ({ img, isHero, onEdit, onDelete, selectMode = false, selected = false, onToggle }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: img.id, disabled: selectMode });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.4 : 1 };

  if (selectMode) {
    return (
      <button type="button" ref={setNodeRef} style={style} onClick={onToggle} data-testid={`gallery-card-${img.id}`} aria-pressed={selected}
        className={`relative rounded-lg overflow-hidden bg-sand/30 text-left ring-4 transition-shadow ${selected ? "ring-jade-deep" : "ring-transparent hover:ring-jade-deep/40"}`}>
        <img src={displayUrl(img.url)} alt={img.alt} className={`w-full aspect-square object-cover ${selected ? "opacity-80" : ""}`} />
        <span data-testid={`gallery-select-check-${img.id}`} className={`absolute top-2 left-2 w-6 h-6 rounded-full flex items-center justify-center border-2 ${selected ? "bg-jade-deep border-jade-deep text-white" : "bg-white/85 border-white"}`}>
          {selected && <Check className="w-4 h-4" />}
        </span>
        <span className="absolute bottom-2 left-2 text-xs bg-white/80 px-2 py-1 rounded">{img.category}</span>
      </button>
    );
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      data-testid={`gallery-card-${img.id}`}
      className="relative group rounded-lg overflow-hidden bg-sand/30 touch-none"
    >
      <img src={displayUrl(img.url)} alt={img.alt} className="w-full aspect-square object-cover" />
      <button
        type="button"
        {...attributes}
        {...listeners}
        data-testid={`gallery-drag-handle-${img.id}`}
        aria-label="Drag to reorder"
        className="absolute top-2 left-2 z-10 p-1.5 rounded-md bg-white/85 text-charcoal cursor-grab active:cursor-grabbing opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <GripVertical className="w-4 h-4" />
      </button>
      {isHero && (
        <span data-testid={`gallery-hero-badge-${img.id}`} className="absolute top-2 right-2 z-10 flex items-center gap-1 text-[10px] uppercase tracking-wider bg-jade-deep text-white px-2 py-1 rounded">
          <Star className="w-3 h-3" /> Hero
        </span>
      )}
      <div className="absolute inset-0 bg-charcoal/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2 pointer-events-none">
        <Button size="sm" variant="secondary" className="pointer-events-auto" data-testid={`gallery-edit-btn-${img.id}`} onClick={() => onEdit(img)}>
          <Pencil className="w-4 h-4" />
        </Button>
        <Button size="sm" variant="destructive" className="pointer-events-auto" data-testid={`gallery-delete-btn-${img.id}`} onClick={() => onDelete(img.id)}>
          <Trash2 className="w-4 h-4" />
        </Button>
      </div>
      <span className="absolute bottom-2 left-2 text-xs bg-white/80 px-2 py-1 rounded">{img.category}</span>
    </div>
  );
};
